<div class="onboard-container container-fluid p-0 row">
  <div class="header col-12 p-0">
    <button type="button" class="btn btn-sm pl-0" [routerLink]="'./'" (click)="openGuide()">
      <span class="mr-2 text-uppercase">View Onboarding</span>
    </button>
  </div>
  <div class="file-container" droppable (onDrop)="attachDocument($event)">
    <div class="col-xs-12 col-sm-6 col-md-4 p-0 pr-1">
      <app-cover-tile *ngIf="coverPage" [coverPage]="coverPage" (save)="saveCoverPage($event)"></app-cover-tile>
    </div>
    <div class="col-xs-12 col-sm-6 col-md-4 p-0 pr-1" *ngFor="let file of files">
      <app-asset-tile
        [showDelete]="true"
        [data]="file"
        (delete)="removeDocument($event)">
      </app-asset-tile>
    </div>
  </div>
</div>
